/* LITTLEG-CONTENT-CONVERTER-RUNTIME-02 */
(() => {
  'use strict';

  const root = document.querySelector('[data-content-converter]');
  if (!root || root.dataset.runtime === 'content-converter-02') return;
  root.dataset.runtime = 'content-converter-02';

  const $ = (selector, scope = root) => scope.querySelector(selector);
  const $$ = (selector, scope = root) => [...scope.querySelectorAll(selector)];
  const SOURCE_CLIENT_STORAGE_KEY = 'littleg:public-source-client:v1';
  const SOURCE_CLIENT_PATTERN = /^[A-Za-z0-9_-]{12,80}$/;

  const state = {
    phase: 'idle',
    sourceUrl: '',
    article: null,
    review: null,
    outputs: {
      website: null,
      facebook: null,
      instagram: null,
    },
    activeChannel: 'website',
    dirty: false,
    acknowledged: false,
  };

  const elements = {
    form: $('[data-import-form]'),
    sourceUrl: $('[data-source-url]'),
    submit: $('[data-import-submit]'),
    formError: $('[data-form-error]'),
    guide: $('[data-empty-guide]'),
    processing: $('[data-processing-state]'),
    error: $('[data-error-state]'),
    errorTitle: $('[data-error-title]'),
    errorMessage: $('[data-error-message]'),
    retry: $('[data-retry-action]'),
    changeUrl: $('[data-change-url-action]'),
    results: $('[data-result-workspace]'),
    resultTitle: $('[data-result-title]'),
    resultMeta: $('[data-result-meta]'),
    sourcePanel: $('[data-source-panel]'),
    sourcePreview: $('[data-source-preview]'),
    review: $('[data-review-status]'),
    reviewHeading: $('[data-review-heading]'),
    reviewSummary: $('[data-review-summary]'),
    reviewIssues: $('[data-review-issues]'),
    reviewAckWrap: $('[data-review-acknowledgement]'),
    reviewAck: $('[data-review-ack]'),
    actionBar: $('[data-action-bar]'),
    currentChannel: $('[data-current-channel]'),
    copy: $('[data-copy-action]'),
    export: $('[data-export-action]'),
    reset: $('[data-reset-action]'),
    exportDialog: $('[data-export-dialog]'),
    resetDialog: $('[data-reset-dialog]'),
    download: $('[data-download-action]'),
    resetConfirm: $('[data-reset-confirm]'),
    toast: $('[data-toast]'),
  };

  const channelLabels = {
    source: '原文',
    website: '网页文章',
    facebook: 'Facebook',
    instagram: 'Instagram',
  };

  function apiEnabled() {
    return root.dataset.apiEnabled === 'true';
  }

  function sourceClientUid() {
    try {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return `src_${window.crypto.randomUUID().replace(/-/g, '')}`;
      }
    } catch (_) {}

    try {
      const bytes = new Uint8Array(16);
      window.crypto.getRandomValues(bytes);
      return `src_${[...bytes].map((value) => value.toString(16).padStart(2, '0')).join('')}`;
    } catch (_) {
      return `src_session_${Date.now().toString(36)}`;
    }
  }

  function publicSourceClientId() {
    try {
      const existing = String(window.localStorage.getItem(SOURCE_CLIENT_STORAGE_KEY) || '').trim();
      if (SOURCE_CLIENT_PATTERN.test(existing)) return existing;
      const created = sourceClientUid();
      window.localStorage.setItem(SOURCE_CLIENT_STORAGE_KEY, created);
      return created;
    } catch (_) {
      if (!window.__littleGPublicSourceSessionId) {
        window.__littleGPublicSourceSessionId = sourceClientUid();
      }
      return window.__littleGPublicSourceSessionId;
    }
  }

  function validWeChatUrl(value) {
    try {
      const url = new URL(value);
      return url.protocol === 'https:' && url.hostname === 'mp.weixin.qq.com';
    } catch (_) {
      return false;
    }
  }

  function showToast(message) {
    elements.toast.textContent = message;
    elements.toast.dataset.visible = 'true';
    window.clearTimeout(showToast.timer);
    showToast.timer = window.setTimeout(() => {
      elements.toast.dataset.visible = 'false';
    }, 2400);
  }

  function setPhase(phase) {
    state.phase = phase;

    elements.guide.hidden = phase !== 'idle';
    elements.processing.hidden = phase !== 'processing';
    elements.error.hidden = phase !== 'error';
    elements.results.hidden = phase !== 'ready';
    elements.actionBar.hidden = phase !== 'ready';

    root.dataset.phase = phase;
  }

  function setProgress(active) {
    const order = ['import', 'review', 'prepare'];

    $$('[data-progress-step]').forEach((item) => {
      const index = order.indexOf(item.dataset.progressStep);
      const activeIndex = order.indexOf(active);

      item.dataset.state =
        index < activeIndex ? 'done' : index === activeIndex ? 'active' : 'waiting';

      item.textContent = `${index < activeIndex ? '✓ ' : ''}${
        {
          import: '读取文章',
          review: '检查内容',
          prepare: '准备不同平台版本',
        }[item.dataset.progressStep]
      }`;
    });
  }

  function normalizeApiError(response, payload) {
    const code = payload?.error?.code || payload?.error || '';

    if (response.status === 429) {
      return '使用次数较多，请稍后再试。';
    }

    if (response.status === 413) {
      return '这篇文章内容较长，暂时无法处理。';
    }

    if (response.status === 422) {
      return '暂时不支持这个文章链接。';
    }

    if (response.status === 504 || code === 'wechat_fetch_timeout') {
      return '读取文章时间较长，请稍后再试。';
    }

    if (code === 'invalid_wechat_url') {
      return '请贴上有效的微信公众号文章链接。';
    }

    return '服务暂时不可用，请稍后再试。';
  }

  async function requestJson(url, body) {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-LittleG-Source-Client': publicSourceClientId(),
      },
      body: JSON.stringify(body),
      credentials: 'omit',
    });

    const payload = await response.json().catch(() => ({}));

    if (!response.ok || payload.ok === false || payload.success === false) {
      const error = new Error(normalizeApiError(response, payload));
      error.status = response.status;
      error.payload = payload;
      throw error;
    }

    return payload.data && typeof payload.data === 'object'
      ? { ...payload, ...payload.data }
      : payload;
  }

  async function importSource(url) {
    return requestJson(root.dataset.importEndpoint, { url });
  }

  async function prepareArticle(article) {
    return requestJson(root.dataset.prepareEndpoint, {
      article,
      targets: ['website', 'facebook', 'instagram'],
    });
  }

  function escapeHtml(value) {
    return String(value || '').replace(
      /[&<>"']/g,
      (char) =>
        ({
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#039;',
        })[char]
    );
  }

  function plainText(html) {
    const holder = document.createElement('div');
    holder.innerHTML = html || '';
    return holder.innerText.replace(/\n{3,}/g, '\n\n').trim();
  }

  function renderSource(article) {
    const metadata = [article.publisher, article.author, article.published_at]
      .filter(Boolean)
      .join(' · ');

    elements.resultTitle.textContent = article.title || '未命名文章';
    elements.resultMeta.textContent = metadata;

    elements.sourcePreview.innerHTML = `
      <h2>${escapeHtml(article.title || '')}</h2>
      ${metadata ? `<p>${escapeHtml(metadata)}</p>` : ''}
      ${article.cover_image ? `<img src="${escapeHtml(article.cover_image)}" alt="">` : ''}
      <div>${article.body_html || ''}</div>
    `;
  }

  function setImage(selector, url) {
    const image = $(selector);

    if (!image) return;

    if (!url) {
      image.hidden = true;
      image.removeAttribute('src');
      return;
    }

    image.src = url;
    image.hidden = false;
  }

  function renderOutputs(outputs) {
    const website = outputs.website || {};
    const facebook = outputs.facebook || {};
    const instagram = outputs.instagram || {};

    state.outputs = { website, facebook, instagram };

    $('[data-website-title]').value = website.title || '';
    $('[data-website-summary]').value = website.summary || '';
    $('[data-website-body]').innerHTML = website.body_html || '';
    $('[data-website-tags]').value = Array.isArray(website.tags) ? website.tags.join(', ') : '';

    setImage('[data-website-cover]', website.cover_image);

    $('[data-facebook-text]').value = facebook.text || '';
    $('[data-facebook-url]').value = facebook.article_url || '';
    setImage('[data-facebook-image]', facebook.image);

    $('[data-instagram-caption]').value = instagram.caption || '';
    $('[data-instagram-hashtags]').value = Array.isArray(instagram.hashtags)
      ? instagram.hashtags.join(' ')
      : '';
    setImage('[data-instagram-image]', instagram.image);
  }

  function renderReview(review) {
    state.review = review || {
      status: 'needs_review',
      summary: '内容检查结果暂时不可用。',
      issues: [],
    };

    const status = state.review.status || 'needs_review';
    elements.review.dataset.status = status;
    elements.reviewIssues.innerHTML = '';

    if (status === 'pass') {
      elements.reviewHeading.textContent = '✓ 内容已检查';
      elements.reviewSummary.textContent = state.review.summary || '未发现明显需要处理的问题';
      elements.reviewAckWrap.hidden = true;
    } else if (status === 'blocked') {
      elements.reviewHeading.textContent = '这篇内容需要先处理';
      elements.reviewSummary.textContent =
        state.review.summary || '部分内容存在明显问题，建议确认后再继续使用生成版本。';
      elements.reviewAckWrap.hidden = false;
    } else {
      elements.reviewHeading.textContent = `有 ${(state.review.issues || []).length} 处内容建议检查`;
      elements.reviewSummary.textContent = state.review.summary || '請在使用前确认这些内容。';
      elements.reviewAckWrap.hidden = true;
    }

    (state.review.issues || []).forEach((issue) => {
      const item = document.createElement('article');
      item.className = 'lgcc__review-issue';

      const heading = document.createElement('strong');
      heading.textContent = issue.severity === 'blocked' ? '需要确认' : '建议检查';

      const message = document.createElement('span');
      message.textContent = issue.message || '';

      item.append(heading, message);

      if (issue.excerpt) {
        const excerpt = document.createElement('em');
        excerpt.textContent = `「${issue.excerpt}」`;
        item.appendChild(excerpt);
      }

      elements.reviewIssues.appendChild(item);
    });

    updateActions();
  }

  function updateActions() {
    const blocked = state.review?.status === 'blocked' && !state.acknowledged;

    elements.copy.disabled = blocked;
    elements.export.disabled = blocked;
  }

  function setActiveChannel(channel) {
    state.activeChannel = channel;

    $$('[data-channel]').forEach((button) => {
      button.setAttribute('aria-selected', String(button.dataset.channel === channel));
    });

    $$('[data-editor]').forEach((panel) => {
      panel.hidden = panel.dataset.editor !== channel;
    });

    if (channel === 'source') {
      elements.sourcePanel.dataset.mobileActive = 'true';
    } else {
      elements.sourcePanel.dataset.mobileActive = 'false';
    }

    elements.currentChannel.textContent = `目前版本：${channelLabels[channel] || channel}`;
  }

  async function runImport() {
    const value = elements.sourceUrl.value.trim();

    if (!apiEnabled()) {
      elements.formError.textContent = '工具执行服务正在准备中。';
      return;
    }

    if (!validWeChatUrl(value)) {
      elements.formError.textContent = '请贴上有效的微信公众号文章链接。';
      elements.sourceUrl.focus();
      return;
    }

    elements.formError.textContent = '';
    state.sourceUrl = value;
    setPhase('processing');
    setProgress('import');

    try {
      const imported = await importSource(value);
      const article = imported.article || imported.data?.article;

      if (!article || !article.body_text) {
        throw new Error('暂时无法读取这篇文章');
      }

      state.article = article;
      renderSource(article);

      setProgress('review');

      const prepared = await prepareArticle(article);

      setProgress('prepare');

      renderReview(prepared.review);
      renderOutputs(prepared.outputs || {});

      state.dirty = false;
      state.acknowledged = false;
      setActiveChannel('website');
      setPhase('ready');
      showToast('已整理完成');
    } catch (error) {
      elements.errorTitle.textContent = '暂时无法完成整理';
      elements.errorMessage.textContent =
        error?.message || '請检查链接后再试一次。部分文章可能无法从公开页面读取。';

      setPhase('error');
    }
  }

  function currentContent(channel = state.activeChannel) {
    if (channel === 'website') {
      const title = $('[data-website-title]').value;
      const summary = $('[data-website-summary]').value;
      const bodyHtml = $('[data-website-body]').innerHTML;
      const tags = $('[data-website-tags]').value.trim();

      return {
        name: 'website',
        text: [title, summary, plainText(bodyHtml), tags].filter(Boolean).join('\n\n'),
        html: [
          `<h1>${escapeHtml(title)}</h1>`,
          `<p>${escapeHtml(summary)}</p>`,
          bodyHtml,
          tags ? `<p>${escapeHtml(tags)}</p>` : '',
        ].join(''),
      };
    }

    if (channel === 'facebook') {
      const text = $('[data-facebook-text]').value;
      const url = $('[data-facebook-url]').value.trim();
      const output = [text, url].filter(Boolean).join('\n\n');

      return {
        name: 'facebook',
        text: output,
        html: `<p>${escapeHtml(output).replace(/\n/g, '<br>')}</p>`,
      };
    }

    if (channel === 'instagram') {
      const caption = $('[data-instagram-caption]').value;
      const hashtags = $('[data-instagram-hashtags]').value;
      const output = [caption, hashtags].filter(Boolean).join('\n\n');

      return {
        name: 'instagram',
        text: output,
        html: `<p>${escapeHtml(output).replace(/\n/g, '<br>')}</p>`,
      };
    }

    return {
      name: 'source',
      text: state.article?.body_text || '',
      html: state.article?.body_html || '',
    };
  }

  async function copyCurrent() {
    try {
      await navigator.clipboard.writeText(currentContent().text);
      showToast('已复制');
    } catch (_) {
      showToast('复制失败，请手动选择内容。');
    }
  }

  function safeFilename(value) {
    return (
      String(value || 'content')
        .normalize('NFKD')
        .replace(/[^\w-]+/g, '-')
        .replace(/-+/g, '-')
        .replace(/^-|-$/g, '')
        .toLowerCase()
        .slice(0, 80) || 'content'
    );
  }

  function downloadExport() {
    try {
      const scope =
        $('input[name="export-scope"]:checked', elements.exportDialog)?.value || 'current';

      const format =
        $('input[name="export-format"]:checked', elements.exportDialog)?.value || 'txt';

      const channels =
        scope === 'all' ? ['website', 'facebook', 'instagram'] : [state.activeChannel];

      const items = channels.map(currentContent);
      let output = '';

      if (format === 'html') {
        output = items
          .map((item) => `<section><h1>${item.name}</h1>${item.html}</section>`)
          .join('\n<hr>\n');
      } else if (format === 'md') {
        output = items.map((item) => `# ${item.name}\n\n${item.text}`).join('\n\n---\n\n');
      } else {
        output = items.map((item) => item.text).join('\n\n---\n\n');
      }

      const blob = new Blob([output], {
        type: format === 'html' ? 'text/html;charset=utf-8' : 'text/plain;charset=utf-8',
      });

      const url = URL.createObjectURL(blob);
      const anchor = document.createElement('a');

      anchor.href = url;
      anchor.download = `${safeFilename(state.article?.title || 'littleg-content')}-${scope}.${format}`;

      document.body.appendChild(anchor);
      anchor.click();
      anchor.remove();

      window.setTimeout(() => URL.revokeObjectURL(url), 500);

      elements.exportDialog.close();
      showToast('已下载');
    } catch (_) {
      showToast('暂时无法下载，请稍后再试。');
    }
  }

  function reset() {
    state.phase = 'idle';
    state.sourceUrl = '';
    state.article = null;
    state.review = null;
    state.outputs = {
      website: null,
      facebook: null,
      instagram: null,
    };
    state.activeChannel = 'website';
    state.dirty = false;
    state.acknowledged = false;

    elements.sourceUrl.value = '';
    elements.reviewAck.checked = false;
    elements.formError.textContent = '';

    setActiveChannel('website');
    setPhase('idle');
    elements.sourceUrl.focus();
  }

  elements.form?.addEventListener('submit', (event) => {
    event.preventDefault();
    runImport();
  });

  elements.retry?.addEventListener('click', runImport);

  elements.changeUrl?.addEventListener('click', () => {
    setPhase('idle');
    elements.sourceUrl.focus();
  });

  $$('[data-channel]').forEach((button) => {
    button.addEventListener('click', () => {
      setActiveChannel(button.dataset.channel);
    });
  });

  elements.reviewAck?.addEventListener('change', (event) => {
    state.acknowledged = event.target.checked;
    updateActions();
  });

  root.addEventListener('input', (event) => {
    if (
      event.target.matches('input, textarea, [contenteditable="true"]') &&
      state.phase === 'ready'
    ) {
      state.dirty = true;
    }
  });

  elements.copy?.addEventListener('click', copyCurrent);

  elements.export?.addEventListener('click', () => {
    elements.exportDialog.showModal();
  });

  elements.download?.addEventListener('click', downloadExport);

  elements.reset?.addEventListener('click', () => {
    if (state.dirty) {
      elements.resetDialog.showModal();
    } else {
      reset();
    }
  });

  elements.resetConfirm?.addEventListener('click', () => {
    elements.resetDialog.close();
    reset();
  });

  setActiveChannel('website');
  setPhase('idle');
})();
